import React, { useState, useEffect, useRef } from 'react'
import generalController from '../../../controllers/generalController'
import { convertPostalToCoordinates } from '../../../utils/googleMapHelper'
import { fetchDealerData, fetchModelData } from '../../../controllers/ActionController'
import ReserveYourMazda from './ReserveYourMazda'
import { localStorageKeys } from '../../../utils/constants'
import { setItemOnLocalStorage } from '../../../utils/helpers'

// HOC for "ReserveYourMazda" component
function ReserveYourMazdaContainer(props) {
  const { modelCode: modelCodeFormParam, modelOption: modelOptionFormParam, dealerId} = props.formExtraParams
  const [initStep, setInitStep] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [vehicleData, setVehicleData] = useState(null);
  const [dealerData, setDealerData] = useState(null);
  const [userLocation, setUserLocation] = useState(null);

  const componentRef = useRef(null)

  useEffect(() => {
    handleInitData();
  }, [])

  // Handle initial data with URL params.
  const handleInitData = async () => {
    const params = generalController.getURLSearchParams();

    console.log(params)

    if (!params) {
      setIsLoading(false);
      return;
    }

    let initVehicleData = null;
    let initUserPosition = null;

    // Vehicle
    if (params.model) {
      const modelParam = decodeURI(params.model).trim();
      const modelParamData = modelParam.split('|');

      if (modelParamData[0] && modelParamData[1]) {
        initVehicleData = await fetchModelData(modelParamData[0], modelParamData[1]);
      }
    } else if (modelCodeFormParam && modelOptionFormParam) {
      initVehicleData = await fetchModelData(modelCodeFormParam, modelOptionFormParam);
    }

    if (initVehicleData) {
      setInitStep(1);
      setVehicleData(initVehicleData);
    } else {
      // If dealerCode is passed but vehicle is not passed,
      // just set the dealer data in localstorage.
      if (params.dealerCode) {
        const dealerData = await fetchDealerData(params.dealerCode);
        if (dealerData && dealerData.dealer) {
          setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData.dealer)
        }
      }
      // If Vehicle isn't successfully found, return here.
      setIsLoading(false);
      return;
    }

    // Dealer
    if (params.dealerCode || dealerId) {
      const dealerData = await fetchDealerData(dealerId ? dealerId : params.dealerCode);

      if (dealerData && dealerData.dealer) {
        const { userPosition } = dealerData;

        // Set the dealer data in localstorage
        // as the user's previously selected dealer.
        setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData.dealer);

        setDealerData(dealerData);
        setInitStep(2);

        // Set dealer geolocation as user location (map center).
        if (userPosition && (userPosition.lat && userPosition.lng)) {
          initUserPosition = userPosition;
        }
      }
    }

    // Location
    if (!initUserPosition) {
      if (params.geolocation) {
        const locationParam = decodeURI(params.geolocation).trim();
        const locationParamDecoded = locationParam.split('|');

        if (locationParamDecoded[0] && locationParamDecoded[1]) {
          initUserPosition = { lat: Number(locationParamDecoded[0]), lng: Number(locationParamDecoded[1]) };
        }
      } else if (params.postalcode) {
        initUserPosition = await convertPostalToCoordinates(params.postalcode);
      }
    }

    if (initUserPosition) {
      setUserLocation(initUserPosition);
    }

    setIsLoading(false);
  }

  return (
    <div className="mz-reserve-your-mazda-container mz-page-top" ref={componentRef}>
      {
        !isLoading && (
          <ReserveYourMazda
            preDefinedVehicleData={vehicleData}
            preDefinedDealerData={dealerData}
            preDefinedUserLocation={userLocation}
            initStep={initStep}
            containerRef={componentRef}
            {...props}
          />
        )
      }
    </div>
  )
}

export default ReserveYourMazdaContainer